import type { AiSearchIndexKey } from '../types';
import type { AiAskSearchIndexBlock } from './normalizeIndexBlocks';

const AI_SEARCH_SECTION_ORDER: AiSearchIndexKey[] = [
  'members',
  'organizations',
  'groups',
  'tags',
  'events',
  'posts',
  'files',
];

export type AiSearchResultsTab =
  | 'members'
  | 'sponsors'
  | 'groups'
  | 'tags'
  | 'events'
  | 'files'
  | 'posts';

export const INDEX_TO_RESULTS_TAB: Record<
  AiSearchIndexKey,
  AiSearchResultsTab
> = {
  members: 'members',
  organizations: 'sponsors',
  groups: 'groups',
  tags: 'tags',
  events: 'events',
  files: 'files',
  posts: 'posts',
};

export const AI_SEARCH_RESULTS_TAB_LABELS: Record<AiSearchResultsTab, string> =
  {
    members: 'Members',
    sponsors: 'Sponsors',
    groups: 'Groups',
    tags: 'Tags',
    events: 'Events',
    files: 'Files',
    posts: 'Posts',
  };

export const AI_SEARCH_RESULTS_TAB_ORDER: AiSearchResultsTab[] = [
  'members',
  'sponsors',
  'groups',
  'tags',
  'events',
  'files',
  'posts',
];

export function getAvailableResultsTabs(
  indexKeys: AiSearchIndexKey[]
): AiSearchResultsTab[] {
  const present = new Set(
    indexKeys.map((index) => INDEX_TO_RESULTS_TAB[index])
  );

  return AI_SEARCH_RESULTS_TAB_ORDER.filter((tab) => present.has(tab));
}

export function sortAiAskSearchIndexBlocks(
  blocks: AiAskSearchIndexBlock[]
): AiAskSearchIndexBlock[] {
  const order = new Map(
    AI_SEARCH_SECTION_ORDER.map((index, position) => [index, position])
  );

  return [...blocks].sort((a, b) => {
    const aOrder = order.get(a.index as AiSearchIndexKey) ?? 999;
    const bOrder = order.get(b.index as AiSearchIndexKey) ?? 999;
    return aOrder - bOrder;
  });
}
